import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Megaphone } from "lucide-react";
import { api, track } from "@/lib/api";

export default function AdSlot({ placement = "homepage_banner", page = "", category = "", showPlaceholder = true }) {
  const [ad, setAd] = useState(null);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    const params = { placement };
    if (page) params.page = page;
    if (category) params.category = category;
    api.get("/ads/active", { params }).then((r) => setAd(r.data[0] || null)).finally(() => setLoaded(true));
  }, [placement, page, category]);

  if (!loaded) return null;

  if (!ad) {
    if (!showPlaceholder) return null;
    return (
      <Link to="/advertise" data-testid="ad-slot-placeholder"
        className="block border border-dashed border-white/15 bg-[#101010] py-4 px-6 text-center hover:border-[#FFEA00] transition-colors group">
        <span className="text-neutral-500 text-sm group-hover:text-[#FFEA00] inline-flex items-center gap-2"><Megaphone size={15} /> Your ad here — advertise with Visit RiNo from $10/day</span>
      </Link>
    );
  }

  return (
    <a href={ad.target_url || "#"} target="_blank" rel="noopener noreferrer" onClick={() => track("ad", ad.id, "click")}
      data-testid={`ad-slot-${ad.id}`}
      className="relative block overflow-hidden border border-[#FFEA00]/40 group">
      <span className="absolute top-2 right-2 z-10 bg-black/70 text-neutral-300 text-[9px] font-accent px-2 py-0.5">Sponsored</span>
      {ad.image ? (
        <div className="relative h-40 sm:h-48">
          <img src={ad.image} alt={ad.headline} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-transparent flex items-center">
            <div className="px-8">
              <div className="text-[#FFEA00] font-accent text-xs">{ad.advertiser_name}</div>
              <div className="text-white font-display font-extrabold text-2xl sm:text-3xl max-w-lg">{ad.headline}</div>
            </div>
          </div>
        </div>
      ) : (
        <div className="bg-gradient-to-r from-[#1a0410] to-[#141414] py-8 px-8">
          <div className="text-[#FFEA00] font-accent text-xs">{ad.advertiser_name}</div>
          <div className="text-white font-display font-extrabold text-2xl">{ad.headline}</div>
        </div>
      )}
    </a>
  );
}
